import { render, staticRenderFns } from "./ControlDia.vue?vue&type=template&id=7f54b53e&scoped=true"
import script from "./ControlDia.vue?vue&type=script&lang=js"
export * from "./ControlDia.vue?vue&type=script&lang=js"
import style0 from "./ControlDia.vue?vue&type=style&index=0&id=7f54b53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f54b53e",
  null
  
)

export default component.exports